const baseCanonicalUrl = 'https://www.owndays.com/sg/en/information';

export const INFORMATION = [
  {
    metaTitle: 'Sat. 1 Mar. 2025 OWNDAYS Punggol Coast Mall Store New Open!',
    targetPath: '/information/1052',
    keywords:
      'Punggol Coast Mall,New Open,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame',
    ogImage: 'https://static.lenskart.com/owndays/img/information/1052/main.webp',
    description: `OWNDAYS Punggol Coast Mall Store Sat. 1 Mar. 2025 New Open, The simple price system with the speedy process, we will be able to give you the glasses after 20 minutes. We will also be able to do the lenses replacement for spectacles that you purchased at other store. Anything about glasses spectacles just let OWNDAYS to serve you.`,
    canonicalUrl: `${baseCanonicalUrl}/1052`,
  },
  {
    metaTitle:
      'OWNDAYS REVAMPS BRAND IDENTITY, DEBUTING NEW RETAIL DESIGN IN JAPAN AND SINGAPORE THIS JULY',
    targetPath: '/information/5001',
    keywords:
      'OWNDAYS,Singapore,eyewear,glasses,sunglasses,rebrand,OWN your DAYS,brand logo,Japan,LaLaport Tachikawa Tachihi,Northpoint City',
    ogImage: 'https://static.lenskart.com/owndays/img/information/20240711/676.webp',
    description: `Japanese eyewear brand OWNDAYS has unveiled a new logo and brand identity today, marking a significant milestone aimed at creating a more unified retail experience globally. With the introduction of a new tagline “OWN ‘your’ DAYS”, the updated identity embodies OWNDAYS’ dedication to inspiring individuality and confidence among its customers.`,
    canonicalUrl: `${baseCanonicalUrl}/5001`,
  },
  {
    metaTitle: 'Thu. 15 Aug. 2024 OWNDAYS Toa Payoh Store Now Open!',
    targetPath: '/information/1043',
    keywords:
      'Toa Payoh Store,Now Open,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame',
    ogImage: 'https://static.lenskart.com/media/owndays/img/information/1043/ogp_1200x630.jpg',
    description: `OWNDAYS Toa Payoh Store Thu. 15 Aug. 2024 Now Open, The simple price system with the speedy process, we will be able to give you the glasses after 20 minutes. We will also be able to do the lenses replacement for spectacles that you purchased at other store. Anything about glasses spectacles just let OWNDAYS to serve you.`,
    canonicalUrl: `${baseCanonicalUrl}/1043`,
  },
  {
    metaTitle: 'Announcement on Product Line Changes',
    targetPath: '/information/5002',
    keywords:
      'eyewear,eyeframe,sunglasses,rebranding,products,in-house,sub-brands,collaborations,Singapore,OWNDAYS,2024,air,sun,essential',
    ogImage: 'https://static.lenskart.com/media/owndays/img/imformation/5002/ogp_1200x630.jpg',
    description: `OWNDAYS through the rebranding, we have restructured our product range to make our eyewear even more attractive and easier to understand for our customers.`,
    canonicalUrl: `${baseCanonicalUrl}/5002`,
  },
  {
    metaTitle: 'Thu. 19 Dec. 2024 OWNDAYS Le Quest Outlet Store New Open!',
    targetPath: '/information/1048',
    keywords:
      'Le Quest Outlet Store,New Open,spectacles,glasses,optical shop,eye glasses,sunglasses,eyewear,pc lenses,frame',
    ogImage: 'https://static1.lenskart.com/owndays/img/information/shops/1048/ogp_1200x630.jpg',
    description: `Thu. 19 Dec. 2024 OWNDAYS Le Quest Outlet Store New Open!, The simple price system with the speedy process, we will be able to give you the glasses after 20 minutes. We will also be able to do the lenses replacement for spectacles that you purchased at other store. Anything about glasses spectacles just let OWNDAYS to serve you.`,
    canonicalUrl: `${baseCanonicalUrl}/1048`,
  },
];
